export default "https://cdn-static.gokick.com/assets/f1ffb082694ccd599c5c343ec9cae3a0a74687d7/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";